<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 轮播图 -->
      <imgSwipper v-if="banners.length > 1">
        <div
          v-for="(item, index) in banners"
          :key="index"
          class="swiper-slide bannerItem"
          slot="swipper-item"
          :style="{'background-image': item.bgurl }"
        >
          <!-- <img :src="item.B_IMG" /> -->
        </div>
      </imgSwipper>

      <!-- 热门产品 -->
      <div class="hotProduct">
        <div class="toptitle" @click="toProduct()">
          <img src="../assets/zszs.png" />
          <span>热门产品</span>
          <img src="../assets/zszs2.png" />
        </div>
        <div class="hotCont">
          <div class="proBox">
            <div
              class="proItem"
              v-for="(item, index) in goods"
              :key="index"
              @click="toProduct()"
            >
              <div class="proItem-ico">
                <img :src="item.P_IMG" />
              </div>
              <div class="proItem-name">
                <span>{{ item.P_NAME }}</span>
              </div>
            </div>
            <div class="seeAll" @click="toProduct()">
              <img src="../assets/qb.png" />
              <span>查看全部</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 关于我们 -->
      <div class="aboutWe">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>关于我们</span>
          <img src="../assets/zszs2.png" />
        </div>
        <!-- 关于我们内容 -->
        <div class="aboutCont">
          <div class="left">
            <p class="name">采航(上海)贸易有限公司</p>
            <p class="line"></p>
            <img src="../assets/company.png" />
          </div>
          <div class="right">
            <p>
              采航(上海)贸易企业有限公司（简称“AST SH”），是VEOLIA Sievers分析仪全国半导体业的总经销商。主要产品是超纯水系统TOC总有机碳分析仪以及UPW Boron超纯水在线硼分析仪，以其独特的设计使得检测范围可以从原水到纯水，覆盖了净化过程中的每个环节，在全球水质检测领域极具影响力!
            </p>
            <p>
              客户分布于全中国，包含TSMC，SMIC，三星，BOE，CSOT，Intel，华虹，华力，积塔，新昇，长江存储，青岛芯恩，天马，维信诺，深超，超视界，华为，比亚迪，晶合，长鑫，鼎泰..等,涵盖所有电子行业指标性客户。
            </p>
            <ul style="margin-bottom: 0">
              <li>
                <i></i>
                AST总部位于台北，成立于1993年，主要从事专业分析仪器销售代理，代理SieversTOC已有超过30年的历史。
              </li>
              <li>
                <i></i>
                AST于2001年设立AST SH办事处，服务大陆地区电子行业客户。
              </li>
              <li>
                <i></i>
                2010年正式成立采航（上海）贸易有限公司，总部位于上海，深耕电子行业水系统TOC在线检测服务，销售台数超过1000台（若包含台湾，超过2000台），有深厚的行业经验技术积累，在各大城市皆有据点提供售后服务，目前有18位资深售后工程师。
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div style="width: 100%; height: 32.8125rem" ></div> -->
      <!-- 合作客户 -->
      <div class="customers">
        <div class="toptitle" style="margin-bottom: 0.5rem">
          <img src="../assets/zszs.png" />
          <span>合作客户</span>
          <img src="../assets/zszs2.png" />
        </div>
        <!-- 合作客户内容 -->

        <div class="swiperBox">
          <div class="prevBtn" @click="proImg()">
            <img src="../assets/scroll1.png" />
          </div>
          <div
            class="swiperInnerBox"
            @mouseenter="stopAuto()"
            @mouseleave="startAuto()"
          >
            <div
              class="imgItem"
              v-for="(item, index) in imgArr"
              :key="index"
              v-show="currentImg == index"
            >
              <img :src="item" />
            </div>
          </div>
          <div class="nextBtn" @click="nextImg()">
            <img src="../assets/scrol2.png" />
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>
<style>
/* 标题 */
.toptitle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* line-height: 30px;
  font-size: 31px; */
  line-height: 1.875rem;
  font-size: 1.9375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2e2e2e;
  /* margin: 70px 0 50px; */
  margin: 4.375rem 0 3.125rem;
}

.toptitle img {
  /* width: 77px;
  height: 14px; */
  width: 4.8125rem;
  height: 0.875rem;
}

.toptitle span {
  /* margin: 0 21px; */
  margin: 0 1.3125rem;
}

.hotCont {
  display: flex;
  justify-content: center;
  width: calc(100% - 8.75rem);
  overflow-x: auto;
  margin: 0 auto;
}

.proBox {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 0 0.4rem;
  box-sizing: border-box;
}

.proItem {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  box-shadow: 0rem 0.0625rem 0.8125rem 0rem rgba(0, 0, 0, 0.1);
  width: calc((100% - 6.5rem) / 5);
  height: 33.4375rem;
  margin: 0 1.625rem 0.4rem 0;
  box-sizing: border-box;
}

.proItem .proItem-ico {
  width: 100%;
  height: 24.9375rem;
  overflow: hidden;
}

.proItem:hover img {
  -webkit-animation: show1 0.5s linear forwards;
  animation: show1 0.5s linear forwards;
}

@-webkit-keyframes show1 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}

@keyframes show1 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}

.proItem .proItem-ico img {
  width: 100%;
  height: 100%;
}

.proItem .proItem-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 80%;
  height: calc(100% - 24.9375rem);
  line-height: 1.5rem;
  font-size: 1.5rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4e4e4e;
}

.proItem .proItem-name span {
  height: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.seeAll {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: calc((100% - 6.5rem) / 5);
  height: 33.4375rem;
  margin: 0 0 0.4rem;
  background: #c1cfdb;
  line-height: 1.3125rem;
  font-size: 1.375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.seeAll img {
  width: 31px;
  height: 31px;
  margin-bottom: 22px;
}

/* 关于我们 */
.hotProduct,
.aboutWe,
.customers {
  width: 100%;
  max-width: 1920px;
  overflow: hidden;
  margin: 0 auto;
}

.aboutWe {
  background: url(../assets/zs1.png) no-repeat left;
  background-size: 100% 100%;
}

.customers {
  background: url(../assets/zs2.png) no-repeat left;
  background-size: 100% 100%;
}

.aboutCont {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  /* width: 70%;
  margin-left: 15%; */
  width: 63%;
  margin-left: 19%;
  box-sizing: 0;
}

.aboutCont .left {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  width: 100%;
}

.aboutCont .name {
  line-height: 2.1875rem;
  font-size: 2.125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin-bottom: 0;
}

.aboutCont .line {
  width: 5.75rem;
  height: 0.25rem;
  background: #020e62;
  margin: 1.0625rem 0 1.1875rem;
}

.aboutCont img {
  width: 100%;
  max-width: 25rem;
  max-height: 14.25rem;
  height: auto;
  object-fit: cover;
}

.aboutCont .right {
  line-height: 1.4375rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #333333;
  padding-left: 2.1875rem;
}

.aboutCont .right p,
.aboutCont .right ul li {
  margin-bottom: 1.1875rem;
}

.aboutCont .right ul li {
  position: relative;
  padding-left: 0.875rem;
}

.aboutCont .right ul li i {
  position: absolute;
  top: 0.875rem;
  left: 0;
  display: inline-block;
  width: 0.3125rem;
  height: 0.3125rem;
  background: #333333;
  border-radius: 50%;
  margin-right: 0.3rem;
}

.aboutCont .right ul li:last-of-type {
  margin-bottom: 0;
}

.aboutCont .right:hover {
  color: #020e62;
}

/* 合作伙伴 */
.swiperBox {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 1.25rem;
}

.swiperInnerBox {
  width: 68%;
  height: 39rem;
}

.imgItem {
  width: 100%;
  height: 100%;
}

.imgItem img {
  width: 100%;
  height: 100%;
  /*设置图片过度效果， 会出现淡入淡出效果 */
  transition: all 0.8s;
}

.prevBtn,
.nextBtn {
  width: 16%;
}

@media (min-width: 1600px) and (max-width: 1800px) {
  .proItem,
  .seeAll {
    height: 26rem;
  }

  .proItem .proItem-ico {
    width: 100%;
    height: 20rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 20rem);
  }

  .swiperInnerBox {
    height: 36rem;
  }
}

@media (min-width: 1411px) and (max-width: 1599px) {
  .proItem,
  .seeAll {
    height: 26rem;
  }

  .proItem .proItem-ico {
    width: 100%;
    height: 20rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 20rem);
  }

  .swiperInnerBox {
    height: 31rem;
  }
}

@media (min-width: 1200px) and (max-width: 1410px) {
  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.8rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 1rem;
  }

  .swiperInnerBox {
    width: 76%;
    height: 30rem;
  }

  .prevBtn,
  .nextBtn {
    width: 12%;
  }

  .hotCont {
    width: calc(100% - 6rem);
  }

  .proItem,
  .seeAll {
    width: calc((100% - 5rem) / 5);
    height: 24rem;
    margin-top: 0.5rem;
  }

  .proItem {
    margin-right: 1.25rem;
  }

  .proItem .proItem-ico {
    width: 100%;
    height: 18rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 18rem);
    font-size: 1.5rem;
  }
}

@media (min-width: 980px) and (max-width: 1199px) {
  .aboutCont {
    width: 80% !important;
    margin-left: 10% !important;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.6rem;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.75rem;
  }

  .swiperInnerBox {
    width: 86%;
    height: 29rem;
  }

  .prevBtn,
  .nextBtn {
    width: 7%;
  }

  .hotCont {
    width: calc(100% - 6rem);
  }

  .proItem,
  .seeAll {
    width: calc((100% - 4rem) / 4);
    height: 21rem;
    margin-top: 0.5rem;
  }

  .proItem {
    margin-right: 1rem;
  }

  .proItem:nth-of-type(4) {
    margin-right: 0;
  }

  .proItem .proItem-ico {
    width: 100%;
    height: 16rem;
  }

  .proItem .proItem-name {
    width: 90%;
    height: calc(100% - 16rem);
    line-height: 1.2rem;
    font-size: 1.2rem;
  }

  .proItem .proItem-name span {
    height: 1.2rem;
  }
}

@media (min-width: 901px) and (max-width: 979px) {
  .aboutCont {
    width: 80% !important;
    margin-left: 10% !important;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.4rem;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.75rem;
  }

  .swiperInnerBox {
    width: 86%;
    height: 27rem;
  }
  .prevBtn,
  .nextBtn {
    width: 7%;
  }

  .hotCont {
    width: calc(100% - 6rem);
  }

  .proItem,
  .seeAll {
    width: calc((100% - 3.6rem) / 3);
    height: 20rem;
    margin-top: 0.5rem;
  }

  .proItem {
    margin-right: 1.2rem;
  }

  .proItem:nth-of-type(3) {
    margin-right: 0;
  }
  
  .proItem .proItem-ico {
    width: 100%;
    height: 17rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 17rem);
    line-height: 1.1rem;
    font-size: 1.1rem;
  }

  .proItem .proItem-name span {
    height: 1.1rem;
  }

  .seeAll {
    font-size: 1.1rem;
  }
}

@media (min-width: 769px) and (max-width: 900px) {
  .hotCont, 
  .aboutCont {
    width: 90% !important;
    margin-left: 5% !important;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.4rem;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.625rem;
  }

  .swiperInnerBox {
    width: 97%;
    height: 25rem;
    margin: 0 auto;
  }

  .prevBtn, .nextBtn {
    display: none;
  }

  .proItem,
  .seeAll {
    width: calc((100% - 3.6rem) / 3);
    height: 19rem;
    margin-top: 0.5rem;
  }

  .proItem {
    margin-right: 1.2rem;
  }

  .proItem:nth-of-type(3) {
    margin-right: 0;
  }
  
  .proItem .proItem-ico {
    width: 100%;
    height: 14rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 14rem);
    line-height: 1.1rem;
    font-size: 1.1rem;
  }

  .proItem .proItem-name span {
    height: 1.1rem;
  }

  .seeAll {
    font-size: 1.1rem;
  }
}

@media (min-width: 601px) and (max-width: 768px) {
  .hotCont, 
  .aboutCont {
    flex-direction: column;
    width: 90% !important;
    margin-left: 5% !important;
  }

  .aboutCont .left,
  .aboutCont .right {
    width: 100%;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
    margin-top: 1.25rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.625rem;
  }

  .aboutCont .line {
    margin: 1rem 0 1.1rem;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.4rem;
  }
  .swiperInnerBox {
    width: 100%;
    height: 22rem;
  }

  .prevBtn,
  .nextBtn {
    display: none;
  }

  .proItem,
  .seeAll {
    width: calc((100% - 3rem) / 3);
    height: 18rem;
    margin-top: 0.5rem;
  }

  .proItem {
    margin-right: 1rem;
  }

  .proItem:nth-of-type(3) {
    margin-right: 0;
  }
  
  .proItem .proItem-ico {
    width: 100%;
    height: 14rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 14rem);
    line-height: 1.1rem;
    font-size: 1.1rem;
  }

  .proItem .proItem-name span {
    height: 1.1rem;
  }

  .seeAll {
    font-size: 1.1rem;
  }
}

@media (min-width: 500px) and (max-width: 600px) {
  .hotCont, 
  .aboutCont {
    flex-direction: column;
    width: 90% !important;
    margin-left: 5% !important;
  }

  .aboutCont .left,
  .aboutCont .right {
    width: 100%;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
    margin-top: 1.25rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.625rem;
  }

  .aboutCont .line {
    margin: 1rem 0 1.1rem;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.4rem;
  }
  .swiperInnerBox {
    width: 100%;
    height: 18rem;
  }

  .prevBtn,
  .nextBtn {
    display: none;
  }

  .proItem,
  .seeAll {
    width: calc((100% - 2rem) / 2);
    height: 18rem;
    margin-top: 0.5rem;
  }

  .proItem {
    margin-right: 1rem;
  }

  .proItem:nth-of-type(2n) {
    margin-right: 0;
  }
  
  .proItem .proItem-ico {
    width: 100%;
    height: 14rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 14rem);
    line-height: 1.1rem;
    font-size: 1.1rem;
  }

  .proItem .proItem-name span {
    height: 1.1rem;
  }

  .seeAll {
    font-size: 1.1rem;
  }
}
@media (min-width: 0px) and (max-width: 499px) {
  .hotCont,
  .aboutCont {
    flex-direction: column;
    width: 96% !important;
    margin: 0 2% !important;
  }

  .aboutCont .left,
  .aboutCont .right {
    width: 100%;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 0.9rem;
    margin-top: 0.9375rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.5rem;
  }

  .aboutCont .line {
    margin: 0.6rem 0 0.6rem;
  }

  .aboutCont .name {
    line-height: 1.8rem;
    font-size: 1.2rem;
  }
  .swiperInnerBox {
    width: 100%;
    height: 13rem;
  }

  .prevBtn,
  .nextBtn {
    display: none;
  }

  .proItem,
  .seeAll {
    width: calc((100% - .625rem) / 2);
    height: 15rem;
    margin-top: .3125rem;
  }

  .proBox {
    justify-content: flex-start;
  }

  .proItem {
    margin-right: .625rem;
  }

  .proItem:nth-of-type(2n) {
    margin-right: 0;
  }

  .proItem .proItem-ico {
    width: 100%;
    height: 12rem;
  }

  .proItem .proItem-name {
    height: calc(100% - 12rem);
    line-height: 1rem;
    font-size: 1rem;
  }

  .proItem .proItem-name span {
    height: 1rem;
  }

  .seeAll {
    font-size: 1rem;
  }
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import imgSwipper from "@/components/imgSwipper.vue";
import { getIndexdata } from "../api/interface"; // 引入接口
export default {
  name: "HomeView",
  components: {
    bottomFooter,
    imgSwipper,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      banners: [],
      bannerSize: 0,
      showView: false,
      imgArr: [
        require("../assets/1.png"),
        require("../assets/2.png"),
        require("../assets/3.png"),
        require("../assets/4.png"),
      ],
      currentImg: 0,
      autoSwitch: 0, //定时器
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
      goods: [],
    };
  },

  created() {
    this.getData();
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
    let autoSwitch = setInterval(() => {
      // 自动切换
      this.nextImg();
    }, 2500);
    this.$set(this, "autoSwitch", autoSwitch);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;

      console.log("scrollTop", scrollTop);

      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
      console.log(this.fontColor);
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取首页数据
    async getData() {
      const that = this;
      await getIndexdata().then((res) => {
        console.log(res);
        if (res.state == "success") {
          let banners = res.banner;
          banners.forEach(v => {
            v[`bgurl`]='url('+ v.B_IMG + ')'
          });
          console.log(banners);
          that.$set(that, "banners", banners);
          let goodsList = res.goods;
          let goods = goodsList.length > 4 ? goodsList.slice(0, 4) : goodsList;
          that.$set(that, "goods", goods);
          console.log(goods);
          let bannerSize = banners.length;
          that.$set(that, "bannerSize", bannerSize);
          if (bannerSize != 0) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 去产品中心
    toProduct() {
      this.$router.push({ path: "/product" });
    },

    // 去关于我们
    toAbout() {
      this.$router.push({ path: "/about" });
    },

    // 切换上一张合作伙伴
    proImg() {
      const that = this;
      let currentImg = that.currentImg;
      if (currentImg == 0) {
        that.$set(that, "currentImg", that.imgArr.length - 1);
      } else {
        that.$set(that, "currentImg", currentImg);
      }
    },

    // 切换下一张合作伙伴
    nextImg() {
      const that = this;
      let currentImg = that.currentImg;
      if (currentImg == that.imgArr.length - 1) {
        that.$set(that, "currentImg", 0);
      } else {
        that.$set(that, "currentImg", currentImg + 1);
      }
    },

    startAuto() {
      // 鼠标离开，再次自动轮播
      let timer = setInterval(() => {
        // 自动切换
        this.nextImg();
      }, 2500);
      this.$set(this, "autoSwitch", timer);
    },

    stopAuto() {
      // 鼠标移动，暂停自动轮播
      clearInterval(this.autoSwitch);
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
